import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AlertAndKey, DailyActivesFrequency } from '@fullstory/client-api';
import { SegmentDetail } from '@fullstory/proto/fs/services/dx-objects';
import { Box, Button, Flex, Typography } from '@fullstory/components';
import css from './configuredAlertItem.module.scss';
import { classNames } from '@fullstory/util/fmt';

export const ConfiguredAlertItem: React.FC<{
  onClick: () => void;
  alert: AlertAndKey;
  segment: SegmentDetail;
}> = ({ alert, segment, onClick }) => (
  <Box
    data-component="ConfiguredAlertItem"
    padding={[16, 24, 0, 24]}
    className={css.container}
    onClick={onClick}
  >
    <Box className={css.borderContainer} paddingBottom={16}>
      <Flex justifyContent="space-between">
        <Box>
          {/* Segment Name */}
          <Box marginBottom={8}>
            <Typography variant="body1">{segment.segment?.segment?.name}</Typography>
          </Box>
          <Box marginBottom={8}>
            <Flex justifyContent="flex-start">
              <FormattedMessage
                defaultMessage="<textStyle>{frequency, select, Daily {Daily} Weekly {Weekly} other {Monthly}} active users</textStyle>
                                <abovePill>{isAbove, select, true {greater than} other {fewer than}}</abovePill>
                                <numberPill>{value, number}</numberPill>"
                id="EeKkSi"
                values={{
                  frequency: DailyActivesFrequency[alert.Alert.Settings.NDayActive],
                  isAbove: alert.Alert.Settings.Above,
                  value: alert.Alert.Settings.Value,
                  textStyle(content) {
                    return (
                      <Box marginRight={8}>
                        <Typography variant="body3">{content}</Typography>
                      </Box>
                    );
                  },
                  abovePill(content) {
                    return (
                      <Typography variant="body3">
                        <Box className={classNames(css.abovePill, 'fs-block')} marginRight={4}>
                          {content}
                        </Box>
                      </Typography>
                    );
                  },
                  numberPill(content) {
                    return (
                      <Typography variant="body3">
                        <Box className={classNames(css.numberPill, 'fs-block')}>{content}</Box>
                      </Typography>
                    );
                  },
                }}
              />
            </Flex>
          </Box>
          <Box>
            <Typography variant="body3" color="neutrals-n7">
              <FormattedMessage
                defaultMessage="Created by: {createdBy}"
                id="w/XbTp"
                values={{
                  createdBy: alert.Alert.CreatedBy,
                }}
              />
            </Typography>
          </Box>
        </Box>
        <Box>
          <Button
            variant="outline"
            onClick={e => {
              e.stopPropagation();
              onClick();
            }}
          >
            <FormattedMessage defaultMessage="Edit" id="wEQDC6" />
          </Button>
        </Box>
      </Flex>
    </Box>
  </Box>
);
